module.exports = __webpack_public_path__ + "files/db8baa254d2c8cc890928bc7acad6ca4.svg";